var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { Button, ConfirmationModal, MessageBanner, Modal, Select, TextArea, Layout, } from '@folio/stripes/components';
import { ProposalStatus, ProposalType, RejectionReason, proposalAllows } from '../../types/api';
import { approveProposal, forwardProposal, rebaseProposal, rejectProposal, requestChanges, submitProposal, } from '../../api/proposalService';
import { getErrorInfo } from '../../utils/getErrorCode';
import { getProposalErrorMessageId } from '../../utils/getErrorMessageId';
import { getErrorKind } from '../../utils/errorKind';
import { PROPOSALS_QUERY_ROOT } from '../../hooks/useProposalList';
/** CZNA-1525 — the change's final approval waits on its target record. */
var TARGET_RECORD_BLOCK_CODES = ['TARGET_RECORD_NOT_APPROVED', 'TARGET_RECORD_CANCELLED'];
var modalFooterStyle = {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '16px',
};
/**
 * The actions of a proposal from PENDING_REVIEW onwards, and the modals behind them.
 *
 * <p>CZNA-778 — this used to be a component that drew its own row of buttons in the pane
 * body. The buttons now sit in the pane header, which belongs to ProposalDetail, so this
 * returns the list for the header and keeps only what still lives in the body. `proposal`
 * may be undefined while the detail is loading, because a hook cannot wait for it.
 */
export var useProposalReviewActions = function (proposal, id, onActionComplete) {
    var intl = useIntl();
    var history = useHistory();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _a = useState(false), showApproveModal = _a[0], setShowApproveModal = _a[1];
    var _b = useState(false), showForwardModal = _b[0], setShowForwardModal = _b[1];
    var _c = useState(false), showRejectModal = _c[0], setShowRejectModal = _c[1];
    var _d = useState(false), showRequestChangesModal = _d[0], setShowRequestChangesModal = _d[1];
    var _e = useState(false), showResubmitModal = _e[0], setShowResubmitModal = _e[1];
    var _f = useState(''), approveComment = _f[0], setApproveComment = _f[1];
    var _g = useState(''), forwardComment = _g[0], setForwardComment = _g[1];
    var _h = useState(''), rejectReason = _h[0], setRejectReason = _h[1];
    var _j = useState(''), rejectComment = _j[0], setRejectComment = _j[1];
    var _k = useState(''), requestChangesComment = _k[0], setRequestChangesComment = _k[1];
    var _l = useState(null), actionError = _l[0], setActionError = _l[1];
    // CZNA-1531 (F10) — approval was refused because the record moved on; the error offers to
    // reopen the proposal over the current version, and the result says what changed.
    var _m = useState(false), staleTarget = _m[0], setStaleTarget = _m[1];
    var _o = useState(null), rebased = _o[0], setRebased = _o[1];
    // The component this replaced unmounted while the next proposal loaded, which reset all
    // of the above; the hook lives in ProposalDetail, which stays mounted across proposals.
    // Reset during render, so the next proposal never shows one frame of the previous
    // proposal's error or modal.
    var _p = useState(id), stateFor = _p[0], setStateFor = _p[1];
    if (stateFor !== id) {
        setStateFor(id);
        setShowApproveModal(false);
        setShowForwardModal(false);
        setShowRejectModal(false);
        setShowRequestChangesModal(false);
        setShowResubmitModal(false);
        setApproveComment('');
        setForwardComment('');
        setRejectReason('');
        setRejectComment('');
        setRequestChangesComment('');
        setActionError(null);
        setStaleTarget(false);
        setRebased(null);
    }
    // Each mutation is started with the id it acts on, and its result is dropped from this
    // hook's state when the detail has meanwhile moved to another proposal — otherwise a
    // late answer about the previous proposal would close a modal or raise an error here.
    var shownId = useRef(id);
    shownId.current = id;
    var handleSuccess = function (forId, closeModal) {
        queryClient.invalidateQueries(['proposal', forId]);
        queryClient.invalidateQueries([PROPOSALS_QUERY_ROOT]);
        queryClient.invalidateQueries(['review-queue']);
        if (forId !== shownId.current)
            return;
        closeModal();
        setActionError(null);
        onActionComplete === null || onActionComplete === void 0 ? void 0 : onActionComplete();
    };
    // CZNA-594 — 403 is a permission refusal, not "the action failed, try again". The
    // resubmit path can hit it (only the author may submit), and so can any review action
    // whose rights changed between rendering the button and clicking it.
    var handleError = function (forId, error, fallbackKey) { return __awaiter(void 0, void 0, void 0, function () {
        var errorInfo, messageId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getErrorInfo(error)];
                case 1:
                    errorInfo = _a.sent();
                    if (forId !== shownId.current)
                        return [2 /*return*/];
                    messageId = fallbackKey;
                    if (errorInfo.status === 409 && errorInfo.code && TARGET_RECORD_BLOCK_CODES.includes(errorInfo.code)) {
                        // CZNA-1525 — the record is not approved yet, or NK cancelled it, since this pane was
                        // drawn. The server's sentence names the record and its state; only a body without one
                        // falls back to ours. The refetch brings the block, whose reason then stays in the pane.
                        queryClient.invalidateQueries(['proposal', forId]);
                        setShowApproveModal(false);
                        setApproveComment('');
                        setActionError(errorInfo.message
                            || intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.approvalBlocked' }));
                        return [2 /*return*/];
                    }
                    if (errorInfo.status === 409 && errorInfo.code === 'TARGET_RECORD_CHANGED') {
                        // CZNA-1403 — the record changed after this amendment was opened; approving would
                        // overwrite that change. "Reload and try again" would fail the same way forever.
                        messageId = 'ui-czna-authorities.proposals.detail.targetRecordChanged';
                        setStaleTarget(true);
                        // Confirming again cannot succeed, and the way out sits in the pane behind the dialog.
                        setShowApproveModal(false);
                        setApproveComment('');
                    }
                    else if (errorInfo.status === 409) {
                        messageId = getProposalErrorMessageId(errorInfo);
                    }
                    else if (errorInfo.status === 403) {
                        messageId = 'ui-czna-authorities.proposals.detail.forbidden';
                    }
                    else if (getErrorKind(errorInfo) === 'timeout') {
                        // CZNA-1625 — no answer in time: the action may have been carried out. "Se nezdařilo"
                        // would invite repeating it; the timeout sentence asks to check the state first.
                        messageId = getProposalErrorMessageId(errorInfo);
                    }
                    setActionError(intl.formatMessage({ id: messageId }));
                    return [2 /*return*/];
            }
        });
    }); };
    var rebaseMutation = useMutation(function (forId) { return rebaseProposal(ky, forId); }, {
        onSuccess: function (data, forId) {
            queryClient.invalidateQueries(['proposal', forId]);
            if (forId !== shownId.current)
                return;
            setActionError(null);
            setStaleTarget(false);
            setRebased(data);
        },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.rebaseError'); },
    });
    var approveMutation = useMutation(function (forId) { return approveProposal(ky, forId, { reviewComment: approveComment || undefined }); }, {
        onSuccess: function (_data, forId) { return handleSuccess(forId, function () { setShowApproveModal(false); setApproveComment(''); }); },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.approveError'); },
    });
    var forwardMutation = useMutation(function (forId) { return forwardProposal(ky, forId, { reviewComment: forwardComment || undefined }); }, {
        onSuccess: function (_data, forId) { return handleSuccess(forId, function () { setShowForwardModal(false); setForwardComment(''); }); },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.forwardError'); },
    });
    var rejectMutation = useMutation(function (forId) {
        if (!rejectReason)
            throw new Error('Rejection reason is required');
        return rejectProposal(ky, forId, {
            rejectionReason: rejectReason,
            reviewComment: rejectComment.trim(),
        });
    }, {
        onSuccess: function (_data, forId) { return handleSuccess(forId, function () { setShowRejectModal(false); setRejectReason(''); setRejectComment(''); }); },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.rejectError'); },
    });
    var requestChangesMutation = useMutation(function (forId) { return requestChanges(ky, forId, { reviewComment: requestChangesComment }); }, {
        onSuccess: function (_data, forId) { return handleSuccess(forId, function () { setShowRequestChangesModal(false); setRequestChangesComment(''); }); },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.requestChangesError'); },
    });
    var resubmitMutation = useMutation(function (forId) { return submitProposal(ky, forId); }, {
        onSuccess: function (_data, forId) { return handleSuccess(forId, function () { return setShowResubmitModal(false); }); },
        onError: function (error, forId) { return handleError(forId, error, 'ui-czna-authorities.proposals.detail.resubmitError'); },
    });
    var rejectionReasonOptions = useMemo(function () { return __spreadArray([
        { value: '', label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.rejectModal.reason.placeholder' }) }
    ], Object.values(RejectionReason).map(function (reason) { return ({
        value: reason,
        label: intl.formatMessage({ id: "ui-czna-authorities.rejectionReason.".concat(reason) }),
    }); }), true); }, [intl]);
    if (!proposal) {
        return { actions: [], element: null };
    }
    // CZNA-594 / CZNA-598 — "znovu odeslat ke schválení" calls the same endpoint as the
    // first submit, and the backend lets only the author through. That rule is no longer
    // restated here: `submit` is in `actions` exactly when the call would succeed.
    var showResubmit = proposalAllows(proposal, 'submit');
    var isPendingReview = proposal.status === ProposalStatus.PENDING_REVIEW;
    var isPendingNationalReview = proposal.status === ProposalStatus.PENDING_NATIONAL_REVIEW;
    var isChangesRequested = proposal.status === ProposalStatus.CHANGES_REQUESTED;
    if (!isPendingReview && !isPendingNationalReview && !isChangesRequested) {
        return { actions: [], element: null };
    }
    // The rules these buttons obey — CZNA-552 (forward at the first stage of a two-stage
    // type, approve only at the stage the caller may act on), CZNA-596 (the local review is
    // organization-scoped), CZNA-781 (no self-review guard: role for the stage decides, not
    // identity) — all still hold. They are stated once, on the backend, in
    // ProposalActionResolver.
    // CZNA-598 — all five of those decisions are now read from the backend rather than
    // recomputed here. What stood in this block was the local mirror of four backend rules
    // at once: the role, the organization scope (CZNA-596), the national-only narrowing of
    // the second stage (CZNA-552) and the two-stage/one-stage branch. The mirror was wrong
    // three times in a week. `actions` is the same evaluation the endpoints enforce, so
    // forward, approve, reject and requestChanges each appear exactly when the call would
    // succeed — including the state conditions, which used to be repeated here as
    // isPendingReview / isPendingNationalReview.
    var showForwardAction = proposalAllows(proposal, 'forward');
    var showApprove = proposalAllows(proposal, 'approve');
    var showReject = proposalAllows(proposal, 'reject');
    var showRequestChanges = proposalAllows(proposal, 'requestChanges');
    var canEditUnderReview = proposalAllows(proposal, 'edit');
    var showReviewActions = showForwardAction || showApprove || showReject
        || showRequestChanges;
    var closeRejectModal = function () {
        setShowRejectModal(false);
        setRejectReason('');
        setRejectComment('');
    };
    var closeRequestChangesModal = function () {
        setShowRequestChangesModal(false);
        setRequestChangesComment('');
    };
    var goToEdit = function () { return history.push("/czna-authorities/proposals/".concat(id, "/edit")); };
    // CZNA-1432 — the help texts say what each action does; whether the proposal would create
    // a record or change a published one, and at which stage it stands, changes that answer.
    var helpValues = {
        kind: proposal.proposalType === ProposalType.UPDATE_EXISTING ? 'update' : 'create',
        stage: isPendingNationalReview ? 'national' : 'local',
    };
    var help = function (key) { return ({
        helpId: "ui-czna-authorities.proposals.detail.".concat(key, ".effect"),
        helpValues: helpValues,
    }); };
    // CZNA-778 — the order is the header's layout: the first entry becomes the primary
    // button. Under review that is the supervisor's decision (forward at the first stage of
    // a two-stage type, otherwise approve), not the edit that used to lead the row; reject
    // goes last, away from the primary. On a returned proposal the author's edit leads.
    // WHICH entries exist is unchanged — each one is still exactly one `actions` flag.
    var actions = [];
    if (showReviewActions) {
        if (showForwardAction) {
            actions.push(__assign(__assign({ key: 'forward', labelId: 'ui-czna-authorities.proposals.detail.forward' }, help('forward')), { onClick: function () { return setShowForwardModal(true); }, disabled: forwardMutation.isLoading }));
        }
        if (showApprove) {
            actions.push(__assign(__assign({ key: 'approve', labelId: 'ui-czna-authorities.proposals.detail.approve' }, help('approve')), { onClick: function () { return setShowApproveModal(true); }, 
                // CZNA-1525 — the backend drops `approve` while a block stands; should the two ever
                // disagree, the block wins and the button stays visibly unavailable. Its reason is
                // drawn by ProposalDetail (TargetRecordStateBanner).
                disabled: approveMutation.isLoading || !!proposal.approvalBlock }));
        }
        if (canEditUnderReview) {
            // CZNA-1525 — while the target record holds the approval, the form this opens offers no
            // „Uložit a schválit" (approve is not in `actions`), so the entry must not promise it; and
            // a cancelled record will never be approved, so its help says what is left instead. Each
            // help id is a literal call: actionHelpMessages.test.ts scans for them.
            var block = proposal.approvalBlock;
            var editEntry = void 0;
            if (!block) {
                editEntry = __assign({ labelId: 'ui-czna-authorities.proposals.detail.editInReview' }, help('editInReview'));
            }
            else if (block.code === 'TARGET_RECORD_CANCELLED') {
                editEntry = __assign({ labelId: 'ui-czna-authorities.proposals.detail.editInReviewBlocked' }, help('editInReviewCancelled'));
            }
            else {
                editEntry = __assign({ labelId: 'ui-czna-authorities.proposals.detail.editInReviewBlocked' }, help('editInReviewBlocked'));
            }
            actions.push(__assign(__assign({ key: 'editInReview' }, editEntry), { onClick: goToEdit }));
        }
        if (showRequestChanges) {
            actions.push(__assign(__assign({ key: 'requestChanges', labelId: 'ui-czna-authorities.proposals.detail.requestChanges' }, help('requestChanges')), { onClick: function () { return setShowRequestChangesModal(true); }, disabled: requestChangesMutation.isLoading }));
        }
        if (showReject) {
            actions.push(__assign(__assign({ key: 'reject', labelId: 'ui-czna-authorities.proposals.detail.reject' }, help('reject')), { onClick: function () { return setShowRejectModal(true); }, disabled: rejectMutation.isLoading }));
        }
    }
    if (isChangesRequested) {
        if (canEditUnderReview) {
            actions.push(__assign(__assign({ key: 'edit', labelId: 'ui-czna-authorities.proposals.detail.edit' }, help('edit')), { onClick: goToEdit }));
        }
        if (showResubmit) {
            actions.push(__assign(__assign({ key: 'resubmit', labelId: 'ui-czna-authorities.proposals.detail.resubmit' }, help('resubmit')), { onClick: function () { return setShowResubmitModal(true); }, disabled: resubmitMutation.isLoading }));
        }
    }
    var element = (React.createElement(React.Fragment, null,
        actionError && (React.createElement(MessageBanner, { type: "error" }, actionError)),
        staleTarget && (React.createElement(Button, { onClick: function () { return rebaseMutation.mutate(id); }, disabled: rebaseMutation.isLoading, "data-test-proposal-rebase": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.rebase" }))),
        rebased && (React.createElement(MessageBanner, { type: "warning", "data-test-proposal-rebased": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.rebased", values: {
                    count: rebased.changedFields.length,
                    fields: rebased.changedFields.join(', '),
                } }))),
        React.createElement(Modal, { open: showForwardModal, label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.forwardModal.heading' }), dismissible: true, onClose: function () { setShowForwardModal(false); setForwardComment(''); } },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement("p", null, intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.forwardModal.message' }, { kind: helpValues.kind })),
                React.createElement(TextArea, { label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.forwardModal.comment' }), value: forwardComment, onChange: function (e) { return setForwardComment(e.target.value); } }),
                React.createElement("div", { style: modalFooterStyle },
                    React.createElement(Button, { onClick: function () { setShowForwardModal(false); setForwardComment(''); } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.forwardModal.cancel" })),
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return forwardMutation.mutate(id); }, disabled: forwardMutation.isLoading },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.forwardModal.confirm" }))))),
        React.createElement(Modal, { open: showApproveModal, label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.approveModal.heading' }), dismissible: true, onClose: function () { setShowApproveModal(false); setApproveComment(''); } },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement("p", null, intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.approveModal.message' }, { kind: helpValues.kind })),
                React.createElement(TextArea, { label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.approveModal.comment' }), value: approveComment, onChange: function (e) { return setApproveComment(e.target.value); } }),
                React.createElement("div", { style: modalFooterStyle },
                    React.createElement(Button, { onClick: function () { setShowApproveModal(false); setApproveComment(''); } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.approveModal.cancel" })),
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return approveMutation.mutate(id); }, disabled: approveMutation.isLoading },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.approveModal.confirm" }))))),
        React.createElement(Modal, { open: showRejectModal, label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.rejectModal.heading' }), dismissible: true, onClose: closeRejectModal },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement(Select, { label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.rejectModal.reason' }), dataOptions: rejectionReasonOptions, value: rejectReason, onChange: function (e) { return setRejectReason(e.target.value); }, required: true }),
                React.createElement(TextArea, { label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.rejectModal.comment' }), value: rejectComment, onChange: function (e) { return setRejectComment(e.target.value); }, required: true }),
                React.createElement("div", { style: modalFooterStyle },
                    React.createElement(Button, { onClick: closeRejectModal },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.rejectModal.cancel" })),
                    React.createElement(Button, { buttonStyle: "danger", onClick: function () { return rejectMutation.mutate(id); }, disabled: !rejectReason || !rejectComment.trim() || rejectMutation.isLoading },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.rejectModal.confirm" }))))),
        React.createElement(Modal, { open: showRequestChangesModal, label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.requestChangesModal.heading' }), dismissible: true, onClose: closeRequestChangesModal },
            React.createElement(Layout, { className: "padding-all-gutter" },
                React.createElement(TextArea, { label: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.requestChangesModal.comment' }), placeholder: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.requestChangesModal.commentPlaceholder' }), value: requestChangesComment, onChange: function (e) { return setRequestChangesComment(e.target.value); }, required: true }),
                React.createElement("div", { style: modalFooterStyle },
                    React.createElement(Button, { onClick: closeRequestChangesModal },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.requestChangesModal.cancel" })),
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return requestChangesMutation.mutate(id); }, disabled: !requestChangesComment.trim() || requestChangesMutation.isLoading },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.detail.requestChangesModal.confirm" }))))),
        React.createElement(ConfirmationModal, { open: showResubmitModal, heading: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.resubmitModal.heading' }), message: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.resubmitModal.message' }), confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.resubmitModal.confirm' }), cancelLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.resubmitModal.cancel' }), onConfirm: function () { return resubmitMutation.mutate(id); }, onCancel: function () { return setShowResubmitModal(false); } })));
    return { actions: actions, element: element };
};
